import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Icons from '../Icons';
import { StyledCheckBoxItem, StyledCheckBox, StyledLabel } from './styled';

const CheckBox = ({
  label,
  indeterminate,
  onChange,
  checked,
  width = 'auto',
  disabled,
  withPropagation,
  testId,
  ...rest
}) => {
  const onClickHandler = e => !withPropagation && e.stopPropagation();

  const checkBoxComponent = (
    <StyledCheckBox
      $disabled={disabled}
      inputProps={{ 'data-testid': testId || label, 'data-value': rest?.['data-value'] }}
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
      onClick={onClickHandler}
      onChange={onChange}
      icon={disabled ? <Icons.DisabledCheckbox /> : <Icons.Checkbox />}
      checkedIcon={disabled ? <Icons.SelectedDisabledCheckbox /> : <Icons.SelectedCheckbox />}
      indeterminateIcon={disabled ? <Icons.IndeterminateDisabledCheckbox /> : <Icons.IndeterminateCheckbox />}
      disableRipple
      {...rest}
    />
  );

  return label ? (
    <StyledCheckBoxItem $width={width}>
      <StyledLabel label={label} control={checkBoxComponent} />
    </StyledCheckBoxItem>
  ) : (
    checkBoxComponent
  );
};

CheckBox.propTypes = {
  label: PropTypes.node,
  onChange: PropTypes.func,
  checked: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  withPropagation: PropTypes.bool,
  testId: PropTypes.string
};

export default forwardRef((props, ref) => <CheckBox ref={ref} {...props} />);
